import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table';
import moment from 'moment';
import Modal from '../../components/Modal';
import { loadCreditHistory, createCreditItem } from '../../actions/ClientActions';
import './CreditModal.less';

@connect(
    state => ({
        creditHistory: state.activeClient.creditHistory,
        saving: state.modal.isSavingCreditHistory
    })
)
export default class CreditModal extends Component {

    static propTypes = {
        client: PropTypes.object.isRequired
    }

    state = {
        creditAmount: null,
        creditReason: null,
        valid: false
    }

    handleAddCredit = () => {
        const { dispatch, client: { id } } = this.props;
        const { creditAmount: amount, creditReason: credit_reason } = this.state;
        dispatch(createCreditItem(id, { amount, credit_reason }));
    }

    isValid = (amount, reason) => {
        return (!!amount && !!reason);
    }

    handleAmountChanged = (e) => {
        const newAmount = e.target.value;
        const valid = this.isValid(newAmount, this.state.creditReason);
        this.setState({creditAmount: newAmount, valid});
    }

    handleReasonChanged = (e) => {
        const newReason = e.target.value;
        const valid = this.isValid(this.state.creditAmount, newReason);
        this.setState({creditReason: newReason, valid});
    }

    componentDidMount() {
        const { dispatch, client: { id } } = this.props;
        dispatch(loadCreditHistory(id));
    }

    render() {
        const { creditHistory, saving } = this.props;
        const { valid } = this.state;
        const actionButton = <button disabled={saving || !valid} onClick={this.handleAddCredit} className='btn btn-success'>{saving ? 'Saving...' : 'Add Credit'}</button>;
        let history = creditHistory || {};
        let creditItems = history.creditItems || [];
        creditItems = creditItems.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1);
        const balance = history.remainingCreditBalance || 0;
        const currency = history.remainingCreditBalanceCurrency || 'NZD';
        let balanceDisplayed = new Intl.NumberFormat([], { style: 'currency', currency: currency }).format(balance);

        return (
            <Modal actionButton={actionButton} className='modal modal-success' title={'Manage Credit'}>
                <div>
                    <h1>Previous Credit Items</h1>
                    {(creditHistory) ?
                    <div>
                        <div className='clientModalTable'>
                            <CreditTable creditItems={creditItems} />
                        </div>
                        <div style={{fontSize: 'large'}}>Remaining available credit: <b>{balanceDisplayed}</b></div>
                    </div> :
                    <div>Loading...</div>
                }
                </div>
                <hr />
                <div>
                    <h1>Add New Credit Item</h1>
                    <div className='input-wrapper'>
                        <div className='input-wrapper-label'>Amount to credit</div>
                        <input
                            disabled={saving}
                            type='number'
                            style={{border: '1px solid #999'}}
                            className='c3-form-input'
                            value={this.state.creditAmount}
                            name='creditAmount'
                            onChange={this.handleAmountChanged}
                            placeholder={0}
                        />
                    </div>
                    <br/>
                    <div className='input-wrapper'>
                        <div className='input-wrapper-label'>Reason for credit</div>
                        <input
                            disabled={saving}
                            style={{border: '1px solid #999'}}
                            className='c3-form-input'
                            value={this.state.creditReason}
                            name='creditReason'
                            onChange={this.handleReasonChanged}
                            placeholder='Adding some credit'
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

const CreditTable = ({creditItems}) => {
    return (
        <Table
            rowsCount={creditItems.length}
            rowHeight={25}
            headerHeight={25}
            width={665}
            maxHeight={450}
        >
        <Column
            header={<Cell>Amount</Cell>}
            width={65}
            cell={props => (
                <Cell {...props}>
                    {creditItems[props.rowIndex].amount}
                </Cell>
            )}
        />
        <Column
            header={<Cell>Reason</Cell>}
            width={290}
            cell={props => (
                <Cell {...props}>
                    {creditItems[props.rowIndex].creditReason}
                </Cell>
            )}
        />
        <Column
            header={<Cell>Authorised By</Cell>}
            width={150}
            cell={props => (
                <Cell {...props}>
                    {creditItems[props.rowIndex].authorisedBy}
                </Cell>
            )}
        />
        <Column
            header={<Cell>Date</Cell>}
            width={160}
            cell={props => (
                <Cell {...props}>
                    {moment.utc(creditItems[props.rowIndex].createdAt).format('MMM Do YYYY hh:mm A')}
                </Cell>
            )}
        />
        </Table>
    );
}


// WEBPACK FOOTER //
// ./app/components/clients/CreditModal.js